var DragScroll = (function () {
   DragScroll = function (options) {
   	this.$scrollArea =  $("."+options.classContainer);
   }
  /*
    DragScroll = function (options) {
      	
        // Mouse dragg scroll

        this.$scrollArea =  $("."+options.classContainer)[0];//$(this);

        //this.$scrollArea.on("mousedown", function(event) {
        this.$scrollArea.onmousedown(function (event) {
            $(this)
                .data('down', true)
                .data('x', event.clientX)
                .data('scrollLeft', this.scrollLeft);

            return false;
        }).mouseup(function (event) {
            $(this).data('down', false);
        }).mousemove(function (event) {
            if ($(this).data('down') == true) {
                this.scrollLeft = $(this).data('scrollLeft') + $(this).data('x') - event.clientX;
            }
        });


        $(window).mouseup(function (event) {
            if ($scrollArea.data('down')) {
                try {
                    if (event.originalTarget.nodeName == 'BODY' || event.originalTarget.nodeName == 'HTML') {
                        $scrollArea.data('down', false);
                    }
                } catch (e) { }
            }
        });


    };
  */
  DragScroll.prototype.doDragScroll = function () {
    
   this.$scrollArea.each(function (i, link) { 
     	var scrolllView = $(this);
     	$(scrolllView).unbind("mousedown");
   		$(scrolllView).mousedown(function (event) {
          //alert("clientX"+ event.clientX);
          //alert( "scrollLeft " + this.scrollLeft);
          //var scrollLeft = 200;
          $(this)
                .data('down', true)
                .data('x', event.clientX)
                .data('scrollLeft', this.scrollLeft);

            return false;
        }).mouseup(function (event) {
            $(this).data('down', false);
        }).mousemove(function (event) {
            if ($(this).data('down') == true) {
                this.scrollLeft = $(this).data('scrollLeft') + $(this).data('x') - event.clientX;
            }
        });

   });
  };
  
  return DragScroll;
}());

/*
var clicked = false, base = 0;

$('#someDiv').on({
    mousemove: function(e) {
        clicked && function(xAxis) {
            var _this = $(this);
            if(base > xAxis) {
                base = xAxis;
                _this.css('margin-left', '-=1px');
            }
            if(base < xAxis) {
                base = xAxis;
                _this.css('margin-left', '+=1px');
            }
        }.call($(this), e.pageX);
    },
    mousedown: function(e) {
        clicked = true;
        base = e.pageX;
    },
    mouseup: function(e) {
        clicked = false;
        base = 0;
    }
});
*/